import type { ReactNode } from 'react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const tones = {
  green: 'border-transparent bg-green-50 text-green-700 dark:bg-green-950 dark:text-green-300',
  amber: 'border-transparent bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300',
  red: 'border-transparent bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300',
  zinc: 'border-transparent bg-muted text-muted-foreground',
  outline: '',
} as const

export type StatusTone = keyof typeof tones

export function StatusBadge({
  tone = 'zinc',
  children,
}: {
  tone?: StatusTone
  children: ReactNode
}) {
  return (
    <Badge
      variant={tone === 'outline' ? 'outline' : 'secondary'}
      className={cn('gap-1 whitespace-nowrap', tones[tone])}
    >
      {children}
    </Badge>
  )
}
